import { Link, useLocation } from 'react-router-dom';

export default function BookingConfirmationPage() {
  const location = useLocation();
  const bookingData = location.state as {
    name?: string;
    preferred_date?: string;
    preferred_time?: string;
  } | null;

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return '';
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-6">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Home
          </Link>
        </div>
      </header>

      <section className="flex-1 flex items-center justify-center pt-12 pb-20 px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-8">
            <i className="ri-check-line text-4xl text-green-600"></i>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-['Fraunces']">
            Thank You{bookingData?.name ? `, ${bookingData.name.split(' ')[0]}` : ''}!
          </h1>

          <p className="text-lg text-gray-600 mb-8 leading-relaxed max-w-lg mx-auto">
            Your intro call request has been submitted successfully. A member of our team will follow up with you
            {bookingData?.preferred_date ? (
              <> on <span className="font-semibold text-gray-900">{formatDate(bookingData.preferred_date)}</span></>
            ) : (
              ' on your desired date'
            )}
            {bookingData?.preferred_time ? (
              <> at <span className="font-semibold text-gray-900">{bookingData.preferred_time}</span></>
            ) : null}
            {' '}to confirm your call.
          </p>

          <div className="bg-[#FDF6F6] border border-[#882629]/10 rounded-2xl p-8 mb-10">
            <div className="flex items-start gap-4 text-left">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-mail-send-line text-xl text-[#882629]"></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-gray-900 mb-1">What happens next?</h3>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-start gap-2">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-[#882629] text-base"></i>
                    </span>
                    You'll receive a confirmation email with your booking details
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-[#882629] text-base"></i>
                    </span>
                    Our team will review your property information
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-[#882629] text-base"></i>
                    </span>
                    We'll reach out to confirm the date and time of your call
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="bg-[#882629] text-white px-8 py-3.5 rounded-full text-sm font-semibold hover:bg-[#6d1e21] transition-all cursor-pointer whitespace-nowrap shadow-md"
            >
              Back to Home
            </Link>
            <a
              href="mailto:contact@furnishedrentalmanagement.com"
              className="border-2 border-gray-300 text-gray-700 px-8 py-3.5 rounded-full text-sm font-semibold hover:border-[#882629] hover:text-[#882629] transition-all cursor-pointer whitespace-nowrap"
            >
              Email Us a Question
            </a>
          </div>

          <p className="text-sm text-gray-500 mt-8">
            Need to reach us sooner? Call{' '}
            <a href="tel:7783869229" className="text-[#882629] font-semibold hover:underline cursor-pointer">
              (778) 386-9229
            </a>
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#505A5A] text-white py-8">
        <div className="max-w-4xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-300">
            &copy; 2025 Compliant Rental Management. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-sm text-gray-300 hover:text-white transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </footer>
    </div>
  );
}
